import React from 'react';
import styled from 'styled-components';

import Button from 'shared/components/Button';
import { colors } from 'lib/prisma-styles';

import { ConfirmationModalFooterProps } from './types';

const StyledConfirmationModalFooterContainer = styled.div`
  margin-top: 1.3rem;
`;

const StyledButton = styled(Button)`
  && {
    font-weight: 700;

    &:not(:last-child) {
      margin-right: 3.67rem;
    }
  }
`;

const StyledSubmitButton = styled(StyledButton)`
  height: 3.67rem;
`;

const StyledCancelButton = styled(StyledButton)`
  && {
    min-width: unset;
    min-height: unset;
    padding: 0;
    background: none;
    color: ${colors.content.default};
  }
`;

const ConfirmationModalFooter = ({
  submitButtonClassName,
  cancelButtonClassName,
  submitButtonLabel,
  cancelButtonLabel,
  isSubmitting,
  isSubmitButtonDisabled,
  isCancelButtonDisabled,
  onCancelClick,
  onSubmitClick,
}: ConfirmationModalFooterProps) => (
  <StyledConfirmationModalFooterContainer>
    <StyledSubmitButton
      className={submitButtonClassName}
      isDisabled={isSubmitButtonDisabled}
      isLoading={isSubmitting}
      label={submitButtonLabel!}
      onClick={onSubmitClick}
    />
    <StyledCancelButton
      className={cancelButtonClassName}
      isDisabled={isCancelButtonDisabled}
      label={cancelButtonLabel!}
      onClick={onCancelClick}
    />
  </StyledConfirmationModalFooterContainer>
);

export { ConfirmationModalFooter };
